import { Link } from "react-router-dom";
import { useSettings } from "../hooks";

export function SiteFooter() {
  const s = useSettings();
  return (
    <footer data-testid="site-footer">
      <span className="veri">Özalp İnşaat — İstanbul</span>
      <span className="veri">
        <Link to="/admin" data-testid="footer-admin-link">Yönetim</Link> · <Link to="/portal" data-testid="footer-portal-link">Daire Sahibi Girişi</Link>
      </span>
      <span className="veri">{s?.phone || ""} · © 2026</span>
    </footer>
  );
}
